export default __webpack_public_path__ + "static/avatar-kayi-common-4-detail-3fc909749a49e6f1c3ffc77aa7636bd5.png";